// extracted by mini-css-extract-plugin
export default {"DataTable":"DataTable_DataTable__NAJtU","Row":"DataTable_Row__wmyOs"};